import { translate } from "app/filters/i18nFilter";

type TitledFilter = {
    key: PropertyKey;
    title?: { key: string } | string | null;
};

/**
 * Builds the `filterKey → resolved title` map used to label leads-filter chips (the Filters tab,
 * team cards, and the territory tooltip all read it). Skips unresolved i18n keys so consumers never
 * render a raw key.
 */
export const buildFilterTitleByKey = (filtersList: readonly TitledFilter[]): ReadonlyMap<string, string> => {
    const map = new Map<string, string>();

    for (const filter of filtersList) {
        const title = filter.title;
        if (!title) {
            continue;
        }

        if (typeof title === "string") {
            map.set(String(filter.key), title);
            continue;
        }

        const resolved = translate(title.key);
        if (resolved && resolved !== title.key) {
            map.set(String(filter.key), resolved);
        }
    }

    return map;
};
